export type PlatformStatus = "available" | "beta" | "soon";

/*
 * Platforms shown on the home (hero strip and Devices section).
 * `status` is the single place to flip when a store listing goes live:
 * available · beta · soon. Keys are tHome() copy keys (i18n.home.ts).
 * `url` is the public store page; the home links the logo and the name to it.
 */
export const PLATFORMS: {
  id: string;
  name: string;
  os: string;
  note: string;
  store: string;
  status: PlatformStatus;
  url?: string;
}[] = [
  { id: "samsung", name: "Samsung", os: "dSamsungOs", note: "dSamsungNote", store: "dSamsungStore", status: "soon" },
  { id: "lg", name: "LG", os: "dLgOs", note: "dLgNote", store: "dLgStore", status: "soon" },
  { id: "roku", name: "Roku", os: "dRokuOs", note: "dRokuNote", store: "dRokuStore", status: "available", url: "https://my.roku.com/account/add/DLTVHLQ" },
  { id: "firetv", name: "Amazon Fire TV", os: "dFireOs", note: "dFireNote", store: "dFireStore", status: "soon" },
  { id: "android", name: "Android TV · Google TV", os: "dAndroidOs", note: "dAndroidNote", store: "dAndroidStore", status: "soon" },
  { id: "appletv", name: "Apple TV", os: "dAppleOs", note: "dAppleNote", store: "dAppleStore", status: "available", url: "https://apps.apple.com/app/id6826727735" },
];
